var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelerIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.4194C0 11.1646 10.7452 0.419434 24 0.419434C37.2548 0.419434 48 11.1646 48 24.4194C48 37.6743 37.2548 48.4194 24 48.4194C10.7452 48.4194 0 37.6743 0 24.4194Z",
    fill: "#F4EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.9194H15.5M18.5 24.4194H14M21 18.9194H16M29 15.4194L22.4036 24.6544C22.1116 25.0632 21.9656 25.2676 21.9719 25.438C21.9774 25.5863 22.0486 25.7245 22.1661 25.8153C22.3011 25.9194 22.5522 25.9194 23.0546 25.9194H28L27 33.4194L33.5964 24.1844C33.8884 23.7757 34.0344 23.5713 34.0281 23.4009C34.0226 23.2526 33.9514 23.1143 33.8339 23.0236C33.6989 22.9194 33.4478 22.9194 32.9454 22.9194H28L29 15.4194Z",
    stroke: "#7F56D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelerIcon2);
export default __webpack_public_path__ + "static/media/traveler_icon_2.1df51939c5c68f6857f4fcaba9abfd02.svg";
export { ForwardRef as ReactComponent };